import { PHASES } from "const/phases.const";
import React from "react";


const ShellContext = React.createContext({
  phaseOn: false,
  phase: PHASES.WAITING,
  loaded: false,
});

export default ShellContext;